import { Action } from "redux";

export const enum ActionTypes {
    CSV_DOWNLOADED = "CSV_DOWNLOADED",
    CLEAR = "CLEAR"
}

export interface ICsvDownloadedAction extends Action {
    type: ActionTypes.CSV_DOWNLOADED;
}

export interface IClearAction extends Action {
    type: ActionTypes.CLEAR;
}

export type TaskActions = ICsvDownloadedAction | IClearAction;


// WEBPACK FOOTER //
// ./src/Store/Tasks/TaskActionTypes.ts